import { useEffect } from 'react';
import { switchSentry } from '@src/bootstrap/sentry.init';
import { useCmp } from '@hooks/useCmp.ts';

export const SentryApp = ({ children }: { children: JSX.Element }) => {
  const consent = useCmp();

  useEffect(() => {
    switchSentry(consent.consentGiven);
  }, [consent.consentGiven]);

  return children;
};
